import styled from 'styled-components';

export const HealthContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 100%;
	flex-shrink: 0;
	padding: 12px 16px;
`;

export const HeaderContainer = styled.div`
	padding: 0 0 8px 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 8px;
`;

export const SectionTitle = styled.h3`
	font-size: 13px;
	font-weight: 600;
	margin: 0;
	color: #111b21;
`;

export const Title = styled.h2`
	font-size: 15px;
	font-weight: 600;
	margin: 0;
`;

export const Subtitle = styled.p`
	font-size: 12px;
	font-weight: 400;
	color: #667781;
	margin: 2px 0 0 0;
`;

export const RefreshButton = styled.button`
	padding: 6px 14px;
	font-size: 13px;
	font-weight: 500;
	border: none;
	border-radius: 6px;
	background: #00a884;
	color: #fff;
	cursor: pointer;

	&:hover {
		background: #008f6f;
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;

export const PhoneCard = styled.div`
	width: 100%;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.1);
	padding: 12px 16px;
	margin-bottom: 16px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const PhoneNumberText = styled.span`
	font-size: 14px;
	font-weight: 600;
	color: #111b21;
`;

export const CampaignActionButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 4px 10px;
	font-size: 12px;
	font-weight: 500;
	border: 1px solid ${ ( { $paused } ) => $paused ? '#00a884' : '#d9534f' };
	border-radius: 6px;
	background: transparent;
	color: ${ ( { $paused } ) => $paused ? '#00a884' : '#d9534f' };
	cursor: pointer;

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;

export const InfoRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 13px;
	color: #54656f;
`;

// Sem scroll próprio: quem rola é o painel das configurações (scroll único, também em
// telas baixas) e o cabeçalho da tabela fica grudado no topo dele.
export const TableWrapper = styled.div`
	width: 100%;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

// minmax(0, …): sem isso a coluna cresce com o conteúdo e um nome de template longo
// empurra as demais colunas; com ele o nome é truncado (TemplateName).
const TABLE_COLUMNS = 'minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) 72px';

// top negativo = padding do SettingsContent (painel que rola): o sticky respeita o padding
// do container e, com top 0, as linhas ficariam visíveis acima do cabeçalho.
export const TableHeader = styled.div`
	position: sticky;
	top: -20px;
	z-index: 2;
	display: grid;
	grid-template-columns: ${ TABLE_COLUMNS };
	padding: 6px 12px;
	border-radius: 8px 8px 0 0;
	background: #e9edef;
	font-size: 11px;
	font-weight: 600;
	color: #54656f;
	text-transform: uppercase;
	letter-spacing: 0.5px;
`;

export const TableRow = styled.div`
	display: grid;
	grid-template-columns: ${ TABLE_COLUMNS };
	padding: 6px 12px;
	align-items: center;
	border-bottom: 1px solid #f0f2f5;

	&:last-child {
		border-bottom: none;
		border-radius: 0 0 8px 8px;
	}

	&:hover {
		background: #f9fafb;
	}
`;

// Nome longo vira "…"; o nome completo aparece no tooltip.
export const TemplateName = styled.span`
	display: block;
	min-width: 0;
	padding-right: 12px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	font-size: 13px;
	color: #111b21;
	font-family: monospace;
`;

export const CellText = styled.span`
	font-size: 12px;
	color: #54656f;
`;

export const StatusText = styled.span`
	font-size: 12px;
	margin-left: 12px;
	color: #667781;
`;

export const ReferenceText = styled.span`
	font-size: 13px;
	font-weight: 500;
	color: #111b21;
`;

export const UnmappedText = styled.span`
	font-size: 12px;
	font-style: italic;
	color: #667781;
`;

export const CenteredHeader = styled.span`
	text-align: center;
`;

export const ConfigCell = styled.div`
	display: flex;
	justify-content: center;
`;

export const ConfigButton = styled.button`
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #d1d7db;
	border-radius: 6px;
	background: #fff;
	color: #00a884;
	cursor: pointer;

	svg {
		width: 18px;
		height: 18px;
	}

	&:hover {
		border-color: #00a884;
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;

export const InfoIcon = styled.span`
	display: inline-flex;
	align-items: center;
	color: #8696a0;
	cursor: help;
	margin-left: 4px;

	svg {
		width: 14px;
		height: 14px;
	}
`;

export const LabelWithInfo = styled.span`
	display: inline-flex;
	align-items: center;
`;

export const SyncButton = styled.button`
	padding: 6px 14px;
	font-size: 13px;
	font-weight: 500;
	border: none;
	border-radius: 6px;
	background: #00a884;
	color: #fff;
	cursor: pointer;

	&:hover {
		background: #008f6f;
	}

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;
